// extracted by mini-css-extract-plugin
module.exports = {"bar":"LowBalanceNotificationBar_bar__2nvV5","notification":"LowBalanceNotificationBar_notification__3uACD"};